<template>
  <div class="active-wrap">
    <template v-if="eventData">
      <div class="active-img-wrap">
        <img
          :src="infos.banner ? baseImgUrl + infos.banner : defaultBannerImage"
          @error="defEventImg($event)"
          alt=""
        />
      </div>
      <div class="active-time">{{ showTime(eventData[$i18n.locale]) }}</div>
      <TextOverflow
        class="active-title"
        :content="infos.title || ''"
        line="2"
        tooltip
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import defaultImg from '@/assets/images/eventBanner.png'
import TextOverflow from '@/components/common/TextOverflow'

export default {
  name: '',
  props: {},
  data() {
    return {
      baseImgUrl: process.env.VUE_APP_NEW_OSS_BASE_URL,
      defaultBannerImage: defaultImg,
    }
  },

  components: { TextOverflow },

  computed: {
    ...mapGetters(['eventData']),
    infos() {
      let obj = null
      let asset = {}
      if (this.eventData) {
        if (this.eventData.languages && this.eventData.languages.length > 1) {
          let lang = this.$i18n.locale === 'en' ? 'en-US' : 'zh-CN'
          asset = this.eventData.asset[lang]
        } else if (this.eventData.languages && this.eventData.languages[0]) {
          asset = this.eventData.asset[this.eventData.languages[0]]
        } else {
          asset = this.eventData.asset['zh-CN']
        }
      }
      obj = {
        ...this.eventData,
        ...asset,
      }
      return obj
    },
  },

  methods: {
    defEventImg(e) {
      let img = e.srcElement
      img.src = defaultImg
      img.onerror = null
    },
    showTime(timeObj) {
      return (
        timeObj && `${timeObj.startFormat}${timeObj.to}${timeObj.endFormat}`
      )
    },
  },
}
</script>
<style lang="scss" scoped>
$black: #14142a;

@keyframes blink {
  0% {
    background: rgba(247, 247, 250, 0.3);
  }
  50% {
    background: rgba(247, 247, 250, 1);
  }
  100% {
    background: rgba(247, 247, 250, 0.3);
  }
}

.active-wrap {
  color: $black;
  flex: 0 0 445px;
}
.active-img-wrap {
  background-color: #f4f4f4;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-name: blink;
  animation-timing-function: linear;
  transition: 0.3s;
  height: 249px;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  img {
    width: 100%;
    vertical-align: top;
  }
}
.active-time {
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 8px;
}

.active-title {
  font-size: 30px;
  line-height: 36px;
  font-weight: 600;
}

.is-mobile {
  .active-wrap {
    flex: 1;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(24px);
    border-radius: 18px;
    padding: 20px;
    margin-bottom: 16px;
  }
  .active-img-wrap {
    height: auto;
  }
  .active-time {
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 6px;
  }
  .active-title {
    font-size: 16px;
    line-height: 22px;
  }
}
</style>
